import {
  MAT_COLOR_FORMATS,
  NgxMatColorPickerModule,
  NGX_MAT_COLOR_FORMATS,
} from "@angular-material-components/color-picker";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { CategoriesModule } from "src/app/shared/modules/categories/categories.module";
import { CustomTableModule } from "src/app/shared/modules/custom-table/custom-table.module";
import { PropertiesModule } from "src/app/shared/modules/properties/properties.module";
import { TopCardMaterialModule } from "src/app/shared/modules/top-card-material/top-card-material.module";
import { FormatPipe } from "src/app/shared/pipes/formatPipe";
import { ProductGroupDetailsComponent } from "./product-group-details/product-group-details.component";
import { ProductGroupListComponent } from "./product-group-list/product-group-list.component";
import { ProductGroupProductsComponent } from "./product-group-products-list/product-group-products-list.component";
import { ProductGroupRoutingModule } from "./product-group-routing.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ProductGroupRoutingModule,
    CustomTableModule,
    TopCardMaterialModule,
    MatProgressBarModule,
    FlexLayoutModule,
    NgxMatColorPickerModule,
    MatCardModule,
    MatIconModule,
    MatTabsModule,
    MatButtonModule,
    MatInputModule,
    MatCheckboxModule,
    MatTooltipModule,
    CategoriesModule,
    PropertiesModule,
  ],
  providers: [
    { provide: MAT_COLOR_FORMATS, useValue: NGX_MAT_COLOR_FORMATS },
    FormatPipe,
  ],

  declarations: [ProductGroupListComponent, ProductGroupDetailsComponent, ProductGroupProductsComponent],
})
export class ProductGroupModule {}
